import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "form"]

  connect() {
    // Long enough to coalesce a burst of typing, short enough that the results
    // still feel attached to the keystroke.
    this.debounceMs = 150
    this.debounceTimer = null
    // Filter bars of selects and dates have no text box to type in.
    if (this.hasInputTarget) this.inputTarget.addEventListener("input", () => this.handleInput())
  }

  handleInput() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => {
      this.form.requestSubmit()
    }, this.debounceMs)
  }

  // For filters that apply as soon as they change, like a select.
  submit() {
    clearTimeout(this.debounceTimer)
    this.form.requestSubmit()
  }

  // The marked form target, or the form the controller sits on or in — so a
  // search form that forgets the target still submits instead of throwing.
  get form() {
    return this.hasFormTarget ? this.formTarget : this.element.closest("form")
  }
}
